import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filter from 'views/accounting/types/filter'; // Importing Filter component
import Table from 'views/accounting/types/table'; // Importing Table component
import { devConfig } from 'config/config'; // Importing development configuration

export default class typesView extends JetView {
    // Defining typesView class extending JetView
    config() {
        // Configuration method for the view
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const screen = this.app.config.size; // Screen size configuration
        const right = {
            // Right section configuration
            type: 'wide',
            rows: [],
        };
        const toolbar = {
            // Toolbar configuration
            view: 'toolbar',
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                // Columns in the toolbar
                {
                    view: 'select', // Dropdown for selecting page size
                    options: ['10', '20', '50', '100'], // Options for page size
                    width: 70,
                    on: {
                        // Event handler for change event
                        onChange: function () {
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable').refresh(); // Refresh the datatable
                        },
                    },
                },
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA',
                    // Template for pager layout
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export',
                    id: 'ExportTypes',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder text
                    options: [
                        // Export options
                        { id: '1', value: 'Excel' },
                        { id: '2', value: 'PDF' },
                    ],
                    on: {
                        // Event handler for change event
                        onChange: function (value) {
                            if (value == 1) {
                                // Excel export
                                var table = $$('datatable'); // Reference to datatable
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    // Loop through columns
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                webix.toExcel(table, {
                                    // Export to Excel
                                    // Filename for the exported file
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Tipos'),
                                    ignore: { rating: true }, // Ignore rating column in export
                                });
                            } else {
                                if (value == 2) {
                                    // PDF export
                                    webix.toPDF($$('datatable'), {
                                        // Export to PDF
                                        // Filename for the exported file
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Tipos'),
                                        autowidth: true, // Auto width for PDF
                                        ignore: { rating: true }, // Ignore rating column in export
                                    });
                                }
                            }
                            $$('ExportTypes').setValue(''); // Reset export selection
                        },
                    },
                },
            ],
        };
        const left = {
            // Left section configuration
            Width: 250,
            responsiveCell: false,
            rows: [
                // Rows in the left section
                {
                    view: 'toolbar', // Toolbar in the left section
                    css: theme, // Apply theme CSS
                    elements: [
                        { id: 'grav' }, // Placeholder element
                        {
                            cols: [
                                // Columns in the toolbar
                                {
                                    view: 'button', // Button to add area
                                    value: _('Añadir Área'), // Button label
                                    type: 'form',
                                    width: screen == 'small' ? 0 : 200, // Conditional width based on screen size
                                    minWidth: 250,
                                    hidden: !devConfig.getPermAction(
                                        // Check permissions for button visibility
                                        'accountingTypeCenterPositionAdd',
                                        'Add',
                                    ),
                                    css: 'prm-accountingTypeCenterPositionAdd', // CSS class for button
                                    click: () => {
                                        // Click event handler
                                        this.app.callEvent('addType:button', [
                                            // Trigger add type event
                                            {},
                                        ]);
                                    },
                                },
                            ],
                        },
                    ],
                },
                Table, // Include Table component
                toolbar, // Include toolbar
            ],
        };
        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            // Return the main configuration object
            id: 'a5',
            type: 'clean',
            view: 'form',
            scroll: 'y',
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    cols: [left], // Include left section
                },
            ],
        };
    }
    init() {
        // Initialization method
        if (screen.width < 500) {
            // Check screen width
            $$('grav').hide(); // Hide element if screen is small
        }
    }
}

// FILE DOCUMENTED
